import { Box, Grid, Typography } from '@mui/material';
import { ILocation } from 'wisestep-api';
import { WsButton, WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';
export interface PreviewProps {
  title: string;
  date: string;
  type: 'EMAIL' | 'CALL' | 'SMS';
  message?: string;
  email?: {
    body: string;
    subject: string;
    jobTitle: string;
    location: ILocation | null;
  };
  onClose?: () => void;
}

const TypographyWithHTMLText = ({ text }: { text?: string }) => (
  <Typography
    variant="body1"
    sx={{
      color: WsTypoColors.BLACK,
    }}
    dangerouslySetInnerHTML={{
      __html: text ? text.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, 'illegalscript') : '',
    }}
  ></Typography>
);

const Preview = ({ title, date, type, message, email, onClose = () => {} }: PreviewProps) => (
  <Box p={2}>
    <Grid container display="flex" justifyContent="space-between" alignItems="center">
      <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK} bold>
        Preview
      </WsTypography>
      <WsButton variant="outlined" size="large" onClick={() => onClose()}>
        Close
      </WsButton>
    </Grid>
    <Grid
      bgcolor={WsColors.White}
      display="flex"
      gap={1}
      direction="column"
      p={2}
      mt={2}
      borderRadius={1}
    >
      <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
        {date}
      </WsTypography>
      <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
        {title}
      </WsTypography>
      <Box
        sx={{
          p: 2,
          bgcolor: WsColors.TertiaryShades50,
          border: `1px solid ${WsColors.TertiaryShades400} `,
          borderRadius: 2,
        }}
      >
        {type != 'EMAIL' ? (
          <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
            {message ?? ''}
          </WsTypography>
        ) : (
          <Box>
            <Grid display="flex">
              <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK} bold>
                Subject:
              </WsTypography>
              <TypographyWithHTMLText text={email?.subject} />
            </Grid>
            <Box py={2}>
              <TypographyWithHTMLText text={email?.body} />
            </Box>
            <Box>
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK} bold>
                {email?.jobTitle ?? ''}
              </WsTypography>
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK} bold>
                {`${email?.location?.city ?? ''},${email?.location?.country ?? ''}`}
              </WsTypography>
            </Box>
          </Box>
        )}
      </Box>
    </Grid>
  </Box>
);
export default Preview;
